import type { ModelEntry } from "../../api";
import { config } from "../../config";

type Props = {
  value: string;
  onChange: (v: string) => void;
  models: ModelEntry[];
};

export function ModelPicker({ value, onChange, models }: Props) {
  const list =
    models.length > 0
      ? models
      : [{ label: "Opus 4.6", model_id: config.opusModel, supported_efforts: [] }];

  return (
    <label>
      Model{" "}
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {list.map((m) => (
          <option key={m.model_id} value={m.model_id}>
            {m.label}
          </option>
        ))}
      </select>
    </label>
  );
}
